import { render, staticRenderFns } from "./InfoBaseDetail.vue?vue&type=template&id=5ba33def"
import script from "./InfoBaseDetail.vue?vue&type=script&lang=js"
export * from "./InfoBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./InfoBaseDetail.vue?vue&type=style&index=0&id=5ba33def&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports